import React from "react";
import { TouchableOpacity, View, StyleSheet, Text } from "react-native";

/**
 * ヘッダーコンポーネント
 * @param props: {onPress: Function, goBackText: string, headerText: string}
 * @returns 
 */
export const Header = ({ onPress, goBackText, headerText, headerTextColor, headerContainerColor }: { onPress?: Function, goBackText?: string, headerText?: string, headerTextColor?: string, headerContainerColor?: string; }) => {

  const styles = StyleSheet.create({
    headerContainer: {
      position: "relative",
      alignItems: "center",
      paddingVertical: 20,
      height: 67,
      boxSizing: "border-box",
    },
    containerColor: {
      backgroundColor: headerContainerColor,
    },
    goBackScreenContainer: {
      position: "absolute",
      left: 20,
    },
    text: {
      fontSize: 18,
      fontWeight: "bold",
    },
    textColor: {
      color: headerTextColor,
    },
  });

  return (
    <View style={[styles.headerContainer, styles.containerColor]}>
      {
        goBackText && <TouchableOpacity style={styles.goBackScreenContainer} onPress={onPress && (() => onPress())}>
          <Text style={[styles.text, styles.textColor]}>
            {goBackText}
          </Text>
        </TouchableOpacity>
      }
      {
        headerText && <Text style={[styles.text, styles.textColor]}>{headerText}</Text>
      }
    </View>
  );
};